import { createSlice } from "@reduxjs/toolkit";
import {
  BecomePartnerData,
  BecomePartnerInitialStatus,
} from "../../../../../types/webCms/aboutUs/become";
import {
  getAllBecomePartnerAsync,
  updateBecomePartnerAsync,
} from "./becomePartnerApi";

const initialState: BecomePartnerInitialStatus<BecomePartnerData> = {
  loading: false,
  manageLoading: false,
  BecomePartnerDataList: [],
  countBecomePartnerData: 0,
};

const becomePartnerSlice = createSlice({
  name: "admin-become-partner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllBecomePartnerAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllBecomePartnerAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.BecomePartnerDataList = action.payload.data;
        state.countBecomePartnerData = action.payload.length;
      })
      .addCase(getAllBecomePartnerAsync.rejected, (state) => {
        state.loading = false;
        state.BecomePartnerDataList = [];
        state.countBecomePartnerData = 0;
      });

    // update
    builder
      .addCase(updateBecomePartnerAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateBecomePartnerAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateBecomePartnerAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default becomePartnerSlice;
